import { render } from "./EmailPreviewPanel.vue?vue&type=template&id=ef5e8d14&scoped=true"
import script from "./EmailPreviewPanel.vue?vue&type=script&lang=js"
export * from "./EmailPreviewPanel.vue?vue&type=script&lang=js"

import "./EmailPreviewPanel.vue?vue&type=style&index=0&id=ef5e8d14&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5e8d14"]])

export default __exports__